import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-calendar-icon',
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()"
      xmlns="http://www.w3.org/2000/svg">
      <g id="vuesax/linear/calendar">
        <g id="calendar">
          <path
            id="Vector"
            d="M8 2V5"
            [attr.stroke]="color()"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_2"
            d="M16 2V5"
            [attr.stroke]="color()"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_3"
            d="M3.5 9.08984H20.5"
            [attr.stroke]="color()"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_4"
            d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
            [attr.stroke]="color()"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_5"
            d="M15.6947 13.7002H15.7037"
            [attr.stroke]="color()"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_6"
            d="M15.6947 16.7002H15.7037"
            [attr.stroke]="color()"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_7"
            d="M11.9955 13.7002H12.0045"
            [attr.stroke]="color()"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_8"
            d="M11.9955 16.7002H12.0045"
            [attr.stroke]="color()"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_9"
            d="M8.29431 13.7002H8.30329"
            [attr.stroke]="color()"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            id="Vector_10"
            d="M8.29431 16.7002H8.30329"
            [attr.stroke]="color()"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </g>
      </g>
    </svg>
  `,
})
export class CalendarIconComponent extends BaseIconComponent {
  override width = input<string>('24');
  override height = input<string>('24');
  override viewBox = input<string>('0 0 24 24');
  override fill = input<string>('none');
}
